import React from 'react';
import 'twin.macro';
import { filterEmpty } from '@/utils/index';
import FooterLI from './FooterLI';
import * as footerTypes from '../../types/FooterTypes.type';

export default function FooterLink(footerProps: footerTypes.FooterListProps) {
  const { items } = footerProps;
  const listItems = filterEmpty(items).map((item) => (
    <FooterLI
      key={item.text}
      text={item.text}
      href={item.url}
      header={false}
      bullet={false}
    />
  ));
  return <ul tw="mb-5 ">{listItems}</ul>;
}
